import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
  ActivatedRoute,
  Router,
  RouterModule,
  RouterOutlet,
} from '@angular/router';
import { NavbarComponent } from './Components/navbar/navbar.component';
import { FooterComponent } from './Components/footer/footer.component';
import { TranslateService } from '@ngx-translate/core';
import { ArabicHandlerService } from './Services/arabicHandler.service';
import { SpinnerService } from './Services/spinner.service';
import { SpinnerComponent } from './Components/spinner/spinner.component';
import { WRONG_SUBDOMAIN } from './app.config';
import { CommonModule } from '@angular/common';
import { Utils } from './utils';
import { SchoolApiService } from './Services/schoolApi.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    NavbarComponent,
    RouterOutlet,
    FooterComponent,
    SpinnerComponent,
    RouterModule,
    CommonModule,
  ],
  providers: [TranslateService, SchoolApiService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'girard-system-fe';

  WRONG_SUBDOMAIN = WRONG_SUBDOMAIN;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private schoolService: SchoolApiService,
  ) {
    this.initializeTranslation();
  }

  ngOnInit() {
    this.schoolService.trackVisits().subscribe();
  }

  ngAfterContentChecked() {
    this.activatedRoute.fragment.subscribe((fragment: string | null) => {
      if (fragment) this.jumpToSection(fragment);
    });
  }

  jumpToSection(section: string | null) {
    if (section)
      document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
  }

  initializeTranslation() {
    this.translate.addLangs(['en', 'fr', 'ar']);

    const storedLang = localStorage.getItem('language') || 'fr';
    this.translate.use(storedLang);
    ArabicHandlerService.handleArabicLanguage(storedLang);
  }

  navigateToTop() {
    Utils.navigateToTop();
  }
}
